import React from 'react';
import BaseContainer from "../containers/common/BaseContainer";
import AccordionForm from "../components/common/AccordionForm";

const AgreePage = ({isTmpCont}) => {
    return (
        <>
            <BaseContainer isTmpCont={isTmpCont} sidebar={false}>
                <AccordionForm />
            </BaseContainer>
        </>
    )
};

export default AgreePage;
